import { useQuery } from '@tanstack/react-query';
import { personService } from '../person.service';
import type { TUsePersonDataConfig, TUsePersonDataReturn } from './use-person-data.types';

const PERSON_DATA_QUERY_KEY = ['person', 'data'] as const;

const usePersonData = (config: TUsePersonDataConfig = {}): TUsePersonDataReturn => {
	const { enabled = true } = config;

	const { data, isLoading, isError, error, refetch, isFetching, isFetched } = useQuery({
		queryKey: PERSON_DATA_QUERY_KEY,
		queryFn: () => personService.getData(),
		enabled,
		staleTime: 1000 * 60 * 5,
		retry: 2
	});

	return {
		person: data,
		isLoading,
		isError,
		error: error,
		refetch: () => {
			void refetch();
		},
		isFetching,
		isFetched
	};
};

export { usePersonData, PERSON_DATA_QUERY_KEY };
